<template>
<div class="login-container" :style="backUrl">
    <div class="login-area">
        <el-form autoComplete="on" :model="loginForm" :rules="loginRules" ref="loginForm" label-position="left" label-width="0px" :show-message="false">
            <h3 class="title">{{indexTitle}}</h3>
            <el-form-item prop="account">
                <el-input prefix-icon="el-icon-user" name="mobilePhone" type="text" v-model="loginForm.account" autoComplete="off" placeholder="账号"></el-input>
            </el-form-item>
            <el-form-item prop="pwd">
                <el-input prefix-icon="el-icon-lock" name="password" type="password" @keyup.enter.native="handleLogin" v-model="loginForm.pwd" autoComplete="off" placeholder="密码"></el-input>
            </el-form-item>
            <div class="tncode" style="text-align: center;"></div>
            <el-form-item class="login-bx">
                <el-button plain style="width:100%;" :loading="loading" @click="handleLogin">登录</el-button>
            </el-form-item>
            <!-- 
      <div class="reset" @click="reset">忘记密码</div> -->
            <!-- <el-form-item class="login-bx">
                <el-button plain style="width:100%;"  @click="reset">
                    重置密码
                </el-button>
      </el-form-item> -->

            <!-- <div class="tips">为保障系统实用效果和用户体验，建议使用IE11.0及以上版本</div> -->
            <!-- <div class="sunLink">
            <span @click="register">帐号注册</span>
        </div> -->
            <div v-if="isShowChromeTip" style="color: red;font-size: 12px; text-align:center">
                为保障系统实用效果和用户体验，建议使用IE11.0及以上版本
                <!-- 请务必使用360浏览器极速模式打开【<a target="_blank" href="http://down.360safe.com/se/360se10.0.1250.0.exe">点击下载</a>】 -->
            </div>
        </el-form>
    </div>

    <vue-particles color="#dedede" :particleOpacity="0.7" :particlesNumber="80" shapeType="circle" :particleSize="4" linesColor="#dedede" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150" :moveSpeed="3" :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push">
    </vue-particles>
</div>
</template>

<script>
import {
    isWscnEmail
} from '@/utils/validate';
import {
    setToken,
    setCookie,
    getCookie
} from '@/utils/auth';
import {
    uuid
} from '@/utils/uuid';
// import {
//     VueParticles
// } from '@/views/components/vue-particles';
// import readBackUrl from '@/assets/images/back2.jpg';
import {
    indexTitle
} from "@/api/login";

export default {
    name: 'login',
    // components:{
    //     VueParticles,
    // },
    data() {
        const validateMobilePhone = (rule, value, callback) => {
            if (!value) {

                callback(new Error('请输入用户名'));

            } else {
                callback();
            }
        };
        const validatePass = (rule, value, callback) => {
            if (value.length < 6) {
                callback(new Error('密码不能小于8位'));

            } else {
                callback();
            }
        };

        return {
            canvasStyle: {
                height: "199px"
            },
            backUrl: '',
            imgUrl: '',
            isVerify: 0,
            indexTitle: '后台管理系统',
            tn: null,
            loginForm: {
                account: '',
                pwd: '',
                imgCode: ''
            },
            loginRules: {
                account: [{
                    required: true,
                    trigger: 'blur',
                    validator: validateMobilePhone
                }],
                pwd: [{
                    required: true,
                    trigger: 'blur',
                    validator: validatePass
                }],
                imgCode: [{
                    required: true,
                    trigger: 'blur',
                    message: '验证码不能为空'
                }],

            },
            loading: false
        }
    },
    computed: {
        isShowChromeTip() {
            var browser = this.checkBrowser();
            var flag = false;
            if (browser != 'Chrome') {
                flag = true;
            }
            // console.log(browser);
            return flag;
        }
    },
    methods: {

        handleLogin() {
            console.log(process.env.NODE_ENV);
            if (!process.env.NODE_ENV == 'development') {
                if (!this.isVerify) {
                    this.$message.error('请先完成验证');
                    console.log('未验证');
                    return;
                }
            }

            var vues = this;

            vues.$refs.loginForm.validate((valid) => {
                if (valid) {
                    vues.loading = true;
                    vues.$store.dispatch('Login', {
                        account: vues.loginForm.account,
                        pwd: md5(vues.loginForm.pwd),
                        imgCode: vues.loginForm.imgCode,
                    }).then((state) => {
                        vues.loading = false;
                        vues.$store.dispatch('setOneLogin', state).then(res => {
                            if (state == 2) {
                                vues.$router.replace({
                                    path: '/paddSet'
                                });
                            } else if (state == 1) {
                                vues.$router.push({
                                    path: '/'
                                });
                            }
                        });

                    }).catch(() => {
                        vues.loading = false;
                        vues.tn.init();
                        vues.isVerify = 0;
                        vues.imgChange();
                    });
                } else {
                    vues.$message.error('请输入账号密码！');
                    vues.tn.init();
                    vues.isVerify = 0;
                }
            })

        },

        imgChange: function () {
            var newTime = Date.parse(new Date());
            this.imgUrl = process.env.BASE_API + "/User/User/getVerifyImg?t=" + uuid() + newTime;
        },

        checkBrowser: function () {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isOpera = userAgent.indexOf("Opera") > -1;
            if (isOpera) {
                return "Opera"
            }; //判断是否Opera浏览器
            if (userAgent.indexOf("Firefox") > -1) {
                return "FF";
            } //判断是否Firefox浏览器
            if (userAgent.indexOf("Chrome") > -1) {
                return "Chrome";
            }
            if (userAgent.indexOf("Safari") > -1) {
                return "Safari";
            } //判断是否Safari浏览器
            if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
                return "IE";
            }; //判断是否IE浏览器
        },
        register: function () {
            this.$router.push('userRegister');
        },
        reset: function () {
            this.$router.push('pass_reset');

        }
    },

    created: function () {
        this.imgChange();
        //    this.backUrl = 'background:url('+ readBackUrl +')';
        indexTitle({}).then(res => {
            console.log(res);
            if (res) {
                this.indexTitle = res;
            }

        });
    },

    mounted: function () {
        this.tn = $TN;
        this.tn.init();
        var vm = this;
        console.log(vm);
        vm.tn.onsuccess(function () {
            vm.isVerify = 1;
        });
        vm.tn.onfailure(function () {
            vm.isVerify = 0;
        });
    }
}
</script>

<style lang="scss">
@import "src/styles/mixin.scss";

.login-container {
    @include relative;
    height: 100vh;
    background-color: #3E5B76;

    // background-image: linear-gradient(rgba(122, 122, 122, 0.1) 0.5px, transparent 0),
    //     linear-gradient(90deg, rgba(112, 112, 112, 0.1) 0.5px, transparent 0),
    //     linear-gradient(hsla(0, 0%, 100%, .3) 0.5px, transparent 0),
    //     linear-gradient(90deg, hsla(0, 0%, 100%, .3) 0.5px, transparent 0);
    // background-size: 175px 175px, 175px 175px, 15px 15px, 15px 15px;

    .login-area {
        position: absolute;
        width: 440px;
        height: 340px;
        left: 50%;
        top: 50%;
        // border: rgb(11, 234, 235);
        box-shadow: 0 0 10px rgb(229, 233, 179);
        margin-left: -220px;
        margin-top: -170px;
        padding: 16px 25px 0px 25px;
        border-radius: 5px;

        .title {
            font-size: 28px;
            letter-spacing: 6px;
            font-weight: 400;

            color: #eeeeee;
            margin: 0px auto;
            text-align: center;

            font-weight: bold;
            margin-bottom: 15px;
        }
    }

    .el-input input {
        background: rgba(51, 49, 49, 0.3) !important;
        color: #eeeeee;
        border: 1px solid rgba(255, 255, 255, 0.1) !important;

    }

    .el-input input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px #293444 inset !important;
        -webkit-text-fill-color: #fff !important;
        background: transparent !important;
    }

    .login-bx {
        margin-top: 25px;

        .el-button {
            // background: rgba(47, 68, 88, 0.8) !important;;
            background: transparent;
            color: white;
            border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .el-button:hover {
            border: 1px solid rgba(255, 255, 255, 0.5);
        }
    }

    // .tips {
    //     font-size: 14px;
    //     color: #fff;
    //     margin-bottom: 5px;
    // }

    // .reset {
    //     font-size: 14px;
    //     color: #fff;
    //     margin-top: -20px;
    //     margin-left: 280px;
    //     cursor: pointer;
    // }

    // .title {
    //     font-size: 32px;
    //     letter-spacing: 6px;
    //     font-weight: 400;
    //     width: 750px;
    //     color: #eeeeee;
    //     margin: 0px auto;
    //     text-align: center;
    //     margin-left: -205px;
    //     font-weight: bold;
    //     margin-bottom: 30px;
    // }

    // .login-form {
    //     position: absolute;
    //     left: 50%;
    //     top: 50%;
    //     width: 340px;
    //     height: 340px;
    //     margin-left: -170px;
    //     margin-top: -240px;

    // }

    // .el-form-item {
    //     margin-bottom: 24px;
    // }

    // .el-input input:-webkit-autofill {
    //     -webkit-box-shadow: 0 0 0px 1000px #293444 inset !important;
    //     -webkit-text-fill-color: #fff !important;
    //     background: transparent !important;
    // }

    // .el-input input {
    //     background: rgba(0, 0, 0, 0.1) !important;
    //     color: #eeeeee;
    //     border: 1px solid rgba(255, 255, 255, 0.1) !important;

    // }

    // input {
    //     background: transparent;
    //     border: 0px;
    //     -webkit-appearance: none;

    // }

    // .login-bx {
    //     margin-top: 30px;

    //     .el-button {
    //         background: transparent;
    //         color: white;
    //         border: 1px solid rgba(255, 255, 255, 0.2);
    //     }

    //     .el-button:hover {
    //         border: 1px solid rgba(255, 255, 255, 0.5);
    //     }
    // }

    // .imgCode {
    //     width: 200px;
    // }

    // .imgbox {
    //     width: 120px;
    //     height: 40px;
    //     border: 1px solid rgba(255, 255, 255, 0.1);
    //     border-radius: 5px;
    //     overflow: hidden;
    //     background: rgba(255, 255, 255, 0.1);
    //     cursor: pointer;
    //     float: right;
    // }

    // .imgbox img {
    //     width: 120px;
    //     height: 40px;
    // }

    // .sunLink {
    //     text-align: center;
    //     margin-top: 20px;
    //     color: #409EFF;
    //     font-size: 14px;
    //     cursor: pointer;
    // }

    // .tips {
    //     font-size: 14px;
    // }

}
</style><style>
.tncode_div {
    background: white;
}
</style>



// WEBPACK FOOTER //
// login.vue?0c08aa96